import { createFileRoute } from '@tanstack/react-router';
import VerifyAccount from '~/components/Auth/Verification/VerifyAccount';

export const Route = createFileRoute('/_public/check-email')({
  component: VerifyAccount,
});
